import styled from "styled-components";

export const PageContainer  = styled.div`
  display : flex;
`
export const PageContent = styled.div`
  background-color : ${props=>props.backgroundColor ? props.backgroundColor : "white" };
  box-sizing: border-box;
  flex-direction : column;
  flex : 8;
  /* overflow : auto; */
  padding  : 30px ;
`;


